import { Enumeration } from '@vantage-point/ddd-core';
import { orderBy } from 'lodash-es';

export class EducationLevelEnum extends Enumeration {
  public static Instances: EducationLevelEnum[] = [];
  public static readonly NinthGrade = new EducationLevelEnum(-4, '9th Grade', {
    emsiDegreeLevel: 0,
    onetEducationLevels: [1],
    oldOnetEducationLevel: 1,

    ordinal: 0,
    normalYearsOfStudy: 0
  });
  public static readonly TenthGrade = new EducationLevelEnum(-3, '10th Grade', {
    emsiDegreeLevel: 0,
    onetEducationLevels: [1],
    oldOnetEducationLevel: 1,

    ordinal: 1,
    normalYearsOfStudy: 0
  });
  public static readonly EleventhGrade = new EducationLevelEnum(-2, '11th Grade', {
    emsiDegreeLevel: 0,
    onetEducationLevels: [1],
    oldOnetEducationLevel: 1,

    ordinal: 2,
    normalYearsOfStudy: 0,
    indefiniteArticle: 'an'
  });
  public static readonly TwelfthGrade = new EducationLevelEnum(-1, '12th Grade', {
    emsiDegreeLevel: 0,
    onetEducationLevels: [1],
    oldOnetEducationLevel: 1,

    ordinal: 3,
    normalYearsOfStudy: 0
  });
  public static readonly HighSchoolDiploma = new EducationLevelEnum(0, 'High School Diploma', {
    emsiDegreeLevel: 0,
    onetEducationLevels: [2],
    oldOnetEducationLevel: 2,

    ordinal: 4,
    normalYearsOfStudy: 0
  });
  public static readonly PostSecondaryCertificate = new EducationLevelEnum(1, 'Post-Secondary Certificate', {
    emsiDegreeLevel: 0,
    ipedsEducationLevels: [7, 8, 9, 12],
    onetEducationLevels: [3],
    csEducationLevels: [1],
    oldOnetEducationLevel: 4,

    ordinal: 5,
    normalYearsOfStudy: 2
  });
  public static readonly SomeCollegeCourses = new EducationLevelEnum(2, 'Some College Courses', {
    emsiDegreeLevel: 0,
    ipedsEducationLevels: [7, 8, 9, 12],
    onetEducationLevels: [4],
    csEducationLevels: [1],
    oldOnetEducationLevel: 4,

    ordinal: 6,
    normalYearsOfStudy: 2
  });
  public static readonly AssociatesDegree = new EducationLevelEnum(3, "Associate's Degree", {
    emsiDegreeLevel: 1,
    ipedsEducationLevels: [1],
    onetEducationLevels: [5],
    csEducationLevels: [2],
    oldOnetEducationLevel: 3,

    ordinal: 7,
    normalYearsOfStudy: 2,
    indefiniteArticle: 'an'
  });
  public static readonly BachelorsDegree = new EducationLevelEnum(4, "Bachelor's Degree", {
    emsiDegreeLevel: 2,
    ipedsEducationLevels: [2],
    onetEducationLevels: [6],
    csEducationLevels: [3],
    oldOnetEducationLevel: 5,

    ordinal: 8,
    normalYearsOfStudy: 4
  });
  public static readonly PostBaccalaureateCertificate = new EducationLevelEnum(5, 'Post-Baccalaureate Certificate', {
    emsiDegreeLevel: 2,
    ipedsEducationLevels: [10],
    onetEducationLevels: [7],
    csEducationLevels: [4],
    oldOnetEducationLevel: 5,

    ordinal: 9,
    normalYearsOfStudy: 2
  });
  public static readonly MastersDegree = new EducationLevelEnum(6, "Master's Degree", {
    emsiDegreeLevel: 3,
    ipedsEducationLevels: [3],
    onetEducationLevels: [8],
    csEducationLevels: [5],
    oldOnetEducationLevel: 6,

    ordinal: 10,
    normalYearsOfStudy: 6
  });
  public static readonly PostMastersCertificate = new EducationLevelEnum(7, "Post-Master's Certificate", {
    emsiDegreeLevel: 3,
    ipedsEducationLevels: [11],
    onetEducationLevels: [9],
    csEducationLevels: [8],
    oldOnetEducationLevel: 6,

    ordinal: 11,
    normalYearsOfStudy: 2
  });
  public static readonly DoctorateDegree = new EducationLevelEnum(8, 'Doctorate Degree', {
    emsiDegreeLevel: 4,
    ipedsEducationLevels: [4, 5, 6],
    onetEducationLevels: [10, 11],
    csEducationLevels: [6, 7],
    oldOnetEducationLevel: 7,

    ordinal: 12,
    normalYearsOfStudy: 8
  });
  public static readonly PostDoctoralTraining = new EducationLevelEnum(9, 'Post-Doctoral Training', {
    emsiDegreeLevel: 4,
    ipedsEducationLevels: [4, 5, 6],
    onetEducationLevels: [10, 11],
    csEducationLevels: [6, 7],
    oldOnetEducationLevel: 7,

    ordinal: 13,
    normalYearsOfStudy: 8
  });

  public emsiDegreeLevel: number;
  public ipedsEducationLevels: number[];
  public onetEducationLevels: number[];
  public csEducationLevels: number[];
  /**
   * @deprecated This property should not be used. Use 'onetEducationLevels' instead.
   */
  public oldOnetEducationLevel: number;

  public ordinal: number;
  public normalYearsOfStudy: number;
  public indefiniteArticle: string;

  private constructor(
    value: number,
    displayName: string,
    options: {
      emsiDegreeLevel: number;
      ipedsEducationLevels?: number[];
      onetEducationLevels: number[];
      csEducationLevels?: number[];
      oldOnetEducationLevel: number;

      ordinal: number;
      normalYearsOfStudy: number;
      indefiniteArticle?: 'a' | 'an';
    }
  ) {
    super(value, displayName);

    this.emsiDegreeLevel = options.emsiDegreeLevel;
    this.ipedsEducationLevels = options.ipedsEducationLevels || [];
    this.onetEducationLevels = options.onetEducationLevels || [];
    this.csEducationLevels = options.csEducationLevels || [];
    (this.oldOnetEducationLevel = options.oldOnetEducationLevel), (this.ordinal = options.ordinal);
    this.normalYearsOfStudy = options.normalYearsOfStudy;
    this.indefiniteArticle = options.indefiniteArticle || 'a';

    EducationLevelEnum.Instances.push(this);
  }

  public static fromValue(value: number): EducationLevelEnum {
    try {
      if (EducationLevelEnum.Instances) {
        const instance = EducationLevelEnum.Instances.filter((item: Enumeration) => item.value === value);

        if (instance != null && instance.length === 1) {
          // console.log('enum ordinal', instance[0].ordinal);
          return instance[0];
        }
      }

      return EducationLevelEnum.HighSchoolDiploma;
    } catch (error) {
      return EducationLevelEnum.HighSchoolDiploma;
    }
  }

  public static fromDisplayName(displayName: string): EducationLevelEnum {
    try {
      if (EducationLevelEnum.Instances) {
        const instance = EducationLevelEnum.Instances.filter((item: Enumeration) => item.displayName === displayName);

        if (instance != null && instance.length === 1) {
          return instance[0];
        }
      }

      return EducationLevelEnum.HighSchoolDiploma;
    } catch (error) {
      return EducationLevelEnum.HighSchoolDiploma;
    }
  }

  public static getStudentCurrentEducationLevelOptions(): EducationLevelEnum[] {
    try {
      if (EducationLevelEnum.Instances) {
        const instances = EducationLevelEnum.Instances.filter((item: Enumeration) =>
          [-4, -3, -2, -1, 0].includes(item.value)
        );

        return orderBy(instances, ['ordinal'], ['asc']);
      }

      return [EducationLevelEnum.HighSchoolDiploma];
    } catch (error) {
      return [EducationLevelEnum.HighSchoolDiploma];
    }
  }

  public static getAdultCurrentEducationLevelOptions(): EducationLevelEnum[] {
    try {
      if (EducationLevelEnum.Instances) {
        const instances = EducationLevelEnum.Instances.filter((item: Enumeration) => [0, 3].includes(item.value));

        return orderBy(instances, ['ordinal'], ['asc']);
      }

      return [EducationLevelEnum.HighSchoolDiploma];
    } catch (error) {
      return [EducationLevelEnum.HighSchoolDiploma];
    }
  }

  public static getEducationLevelGoalOptions(): EducationLevelEnum[] {
    try {
      if (EducationLevelEnum.Instances) {
        const instances = EducationLevelEnum.Instances.filter((item: EducationLevelEnum) =>
          [0, 3, 4].includes(item.value)
        );

        return orderBy(instances, ['ordinal'], ['asc']);
      }

      return [EducationLevelEnum.HighSchoolDiploma];
    } catch (error) {
      return [EducationLevelEnum.HighSchoolDiploma];
    }
  }

  public static getEducationLevelByIpedsId(ipedsEducationLevelTypeIds: number[]): EducationLevelEnum[] {
    const educationLevelByEducationLevelEnum = EducationLevelEnum.Instances.filter((item: EducationLevelEnum) =>
      item.ipedsEducationLevels.some(id => ipedsEducationLevelTypeIds.includes(id))
    );
    return educationLevelByEducationLevelEnum;
  }

  public static getEducationLevelByIpedId(ipedsEducationLevelTypeId: number): EducationLevelEnum | undefined {
    return EducationLevelEnum.Instances.find((item: EducationLevelEnum) =>
      item.ipedsEducationLevels.includes(ipedsEducationLevelTypeId)
    );
  }

  public static getAllByOnetEducationLevelTypeId(onetEducationLevelTypeId: number): EducationLevelEnum[] {
    try {
      const instances = EducationLevelEnum.Instances.filter((item: EducationLevelEnum) =>
        item.onetEducationLevels.includes(onetEducationLevelTypeId)
      );

      if (onetEducationLevelTypeId == null || instances?.length == 0) {
        return [EducationLevelEnum.HighSchoolDiploma];
      }

      return instances;
    } catch (error) {
      return [EducationLevelEnum.HighSchoolDiploma];
    }
  }

  public static getFirstByOnetEducationLevelTypeId(onetEducationLevelTypeId: number): EducationLevelEnum | null {
    try {
      const educationLevels = this.getAllByOnetEducationLevelTypeId(onetEducationLevelTypeId);

      if (educationLevels?.length) {
        return orderBy(educationLevels, ['ordinal'], ['asc'])[0];
      }

      return null;
    } catch (error) {
      return null;
    }
  }

  public static getByOldOnetEducationLevelTypeId(oldOnetEducationLevelTypeId: number): EducationLevelEnum {
    try {
      const instance = EducationLevelEnum.Instances.filter(
        (item: EducationLevelEnum) => item.oldOnetEducationLevel === oldOnetEducationLevelTypeId
      );

      if (oldOnetEducationLevelTypeId == null || instance?.length == 0) {
        return EducationLevelEnum.HighSchoolDiploma;
      }

      return instance[0];
    } catch (error) {
      return EducationLevelEnum.HighSchoolDiploma;
    }
  }
}
